import apiClient from "../../../api/client";
import { BASE_URL } from "config/api";

export async function loadAffectationResources() {
  const [vehiclesRes, usersRes] = await Promise.all([
    apiClient.get(`${BASE_URL}/vehicules`),
    apiClient.get(`${BASE_URL}/users`),
  ]);

  const vehiclesList = Array.isArray(vehiclesRes.data) ? vehiclesRes.data : [];
  const usersList = Array.isArray(usersRes.data) ? usersRes.data : [];
  const ambulanciersList = usersList.filter((u) => u.rôle === "ambulancier");
  const ambulancierIds = new Set(
    ambulanciersList
      .map((u) => Number(u.id))
      .filter((id) => !Number.isNaN(id) && id > 0)
  );

  const hasValidAmbulancier = (vehicle) => {
    const raw = vehicle?.user_id ?? vehicle?.ambulancier_id;
    if (raw === null || raw === undefined || raw === "") return false;
    const idNum = Number(raw);
    if (Number.isNaN(idNum) || idNum <= 0) return false;
    return ambulancierIds.has(idNum);
  };

  const isVehicleAvailable = (vehicle) => {
    const rawStatus =
      vehicle?.statut ??
      vehicle?.status ??
      vehicle?.etat ??
      vehicle?.disponibilité ??
      vehicle?.disponibilite ??
      vehicle?.état;
    if (rawStatus === null || rawStatus === undefined || rawStatus === "") return false;
    const normalized = String(rawStatus).trim().toLowerCase();
    return normalized.includes("disponible") || normalized.includes("available");
  };

  const vehicles = vehiclesList.filter((v) => hasValidAmbulancier(v) && isVehicleAvailable(v));

  return { vehicles, ambulanciers: ambulanciersList };
}
